import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import BasePrizeComponent from '@/components/game/implementations/_base/_components/prize';
import { IPrizeStake } from '@/components/game/implementations/_default/_domain/models';

@Component({
  name: 'HamsterRacePrizeComponent'
})
export default class HamsterRacePrizeComponent extends BasePrizeComponent {
  protected mounted() {
    Vue.nextTick(() => {
      this.gameController
          .onGameStateChanged(this.handleGameStateChanged)
          .onGameRepresentationChanged(this.handleGameRepresentationChanged);
    });
  }

  private get hamsterRaceGamePrizeStructureStakes(): IPrizeStake[] {
    return this.gamePrizeStructure ? this.gamePrizeStructure.stakes : [];
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/hamster-race/_components/prize/prize.component.ts